import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSupplierRequest } from '../queryKeys';

import { processSupplierRequest } from './processSupplierRequest';
import {
  type ProcessSupplierRequestMutationOptions,
  type ProcessSupplierRequestVariables,
} from './types';

/**
 * Mutation hook for resolving a pending supplier request.
 * Invalidates the list and detail caches on settled.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Supplier-Requests/operation/process_request_vadmin_supplier_requests__req_id__patch
 */
export const useMutationProcessSupplierRequest = (
  options?: ProcessSupplierRequestMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ body, reqId }: ProcessSupplierRequestVariables) =>
      processSupplierRequest(reqId, body),
    onSettled(_data, _error, variables) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplierRequest.getAll(),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplierRequest.get(variables?.reqId),
      });
    },
    ...options,
  });
};
